module.exports = __webpack_public_path__ + "954a185b596e8a9f37fa7c5f8842f724.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/snow.svg
// module id = 782
// module chunks = 0